import React from "react";
import { requireAuth } from "../util/auth";
import { Container } from "@material-ui/core";
import CreateSequenceForm from "../components/CreateSequenceForm";
import ListSequences from "../components/ListSequences";

function SequencesPage() {
  return (
    <Container maxWidth="md">
      <h1>My Sequences</h1>
      <CreateSequenceForm />
      <ListSequences />
    </Container>
  );
}

export default requireAuth(SequencesPage);
